import { FC } from 'react'

import { useQueryApi } from 'peach/data/useQueryApi'

import { R } from 'core/helpers'
import { isNotFoundError } from 'core/helpers/error'
import { useInvestorGet } from 'core/types'

import ModelLink from './ModelLink'

type InvestorLinkProps = {
  investorId: string
}

const InvestorLink: FC<InvestorLinkProps> = ({ investorId }) => {
  const [_, { companyId }] = useQueryApi()
  const { data: investor, isLoading } = useInvestorGet({
    companyId,
    investorId,
    options: {
      throwOnError: R.isNot(isNotFoundError),
    },
  })

  const link = companyId && `/companies/${companyId}/investors/${investorId}`

  return (
    <ModelLink
      id={investorId}
      isLoading={isLoading}
      link={link}
      model={investor}
    />
  )
}

export default InvestorLink
